<template>
    <div v-for="(preview, i) in previews" class="d-inline">
        <img :src="preview" @click="showImg(i)" role="button" :alt="altTag" />
    </div>

    <vue-easy-lightbox :visible="visibleRef" :imgs="imgsRef" :index="indexRef" @hide="onHide"></vue-easy-lightbox>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox'
import { ref } from "vue";

export default {
    components: {
        VueEasyLightbox
    },
    props: {
        altTag: String,
        previews: Array,
        images: Array,
    },
    setup(props) {
        const visibleRef = ref(false);
        const indexRef = ref(0);
        const imgsRef = ref(props.images);

        const onShow = () => {
        visibleRef.value = true
        }
        const showImg = (index) => {
            indexRef.value = index
            visibleRef.value = true
            onShow()
        }
        const onHide = () => visibleRef.value = false

        return {
            visibleRef,
            indexRef,
            imgsRef,
            showImg,
            onHide
        }
    }
}
</script>
